if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // NextDev cart drawer: see the same wiring in assets/product-form.js.
      // Null when the drawer markup is not on the page -> plain submit to /cart.
      this.cart =
        (typeof getNextDevCartAdapter === 'function' && getNextDevCartAdapter()) || null;
      this.submitButton = this.querySelector('[type="submit"]');
      this.cancelButton = this.querySelector('[type="cancel"]');
      if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      if (this.submitButton != null) {
        this.submitButton.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
      if (this.cancelButton != null) {
        this.cancelButton.addEventListener('click', this.onCancelHandler.bind(this));
      }

      /* Start - Add to Cart Upsell Modal */
      this.upsellModal = document.querySelector('.nextdev--product-upsell-modal');

      if (this.upsellModal != null) {
        const upsellModalClose = this.upsellModal.querySelector('.nextdev--product-upsell-modal--close');
        const upsellModalCancel = this.upsellModal.querySelector('.nextdev--product-upsell-modal--product__info--buttons button[name="cancel"]');
        const upsellModalContinueShopping = this.upsellModal.querySelector('.nextdev--product-upsell-modal--product__info--buttons button[name="continue_shopping"]');
        const upsellModalContinueToCart = this.upsellModal.querySelector('.nextdev--product-upsell-modal--product__info--buttons button[name="continue_to_cart"]');

        if (upsellModalCancel != null) {
          upsellModalCancel.addEventListener('click', (e) => {
            e.preventDefault();

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.open();

            window.ProductUpsellModalCountdown?.stop();
            this.upsellModal.classList.add('hide');
            document.body.classList.remove('overflow-hidden');
          });
        }
        if (upsellModalContinueToCart != null) {
          upsellModalContinueToCart.addEventListener('click', (e) => {
            e.preventDefault();

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.open();

            window.ProductUpsellModalCountdown?.stop();
            this.upsellModal.classList.add('hide');
            document.body.classList.remove('overflow-hidden');
          });
        }
        if (upsellModalContinueShopping != null) {
          upsellModalContinueShopping.addEventListener('click', (e) => {
            e.preventDefault();

            window.ProductUpsellModalCountdown?.stop();
            this.upsellModal.classList.add('hide');
            document.body.classList.remove('overflow-hidden');
          });
        }

        upsellModalClose.addEventListener('click', (e) => {
          e.preventDefault();
      
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          this.cart.open(upsellModalCancel);

          window.ProductUpsellModalCountdown?.stop();
          this.upsellModal.classList.add('hide');
          document.body.classList.remove('overflow-hidden');
        });
      }
      /* End - Add To Cart Upsell Modal */
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      /* Start - Add To Cart Upsell Modal */
      if (this.upsellModal != null && this.form.classList.contains('form--upsell')) {
        document.body.classList.add('overflow-hidden');
        this.upsellModal.classList.remove('hide');

        const countdownMinutes = this.upsellModal.querySelector('.nextdev--product-upsell-modal--countdown-timer-minutes').dataset.minutes;
        window.ProductUpsellModalCountdown?.start({ durationMs: parseInt(countdownMinutes) * 60 * 1000 });
      } else if (this.form.classList.contains('form--upsell-modal')) {
        window.ProductUpsellModalCountdown?.stop();
        this.upsellModal.classList.add('hide');
        document.body.classList.remove('overflow-hidden');

        document.querySelector('form.form--upsell').classList.remove('form--upsell');
      }
      /* End - Add To Cart Upsell Modal */

      /* Start - Sticky Add to Cart */
      const stickyAddToCart = document.querySelector('.nextdev--sticky-atc');
      if (stickyAddToCart != null) {
        const stickyAddToCartOptions = stickyAddToCart.querySelectorAll('.nextdev--sticky-atc__product-options select');
        const stickyAddToCartButton = stickyAddToCart.querySelector('.nextdev--sticky-atc__product-button');
        const stickyAddToCartBtn = stickyAddToCartButton.querySelector('button');
        const stickyAddToCartBtnContent = stickyAddToCartBtn.querySelector('.button--content');
        const stickyAddToCartBtnLoading = stickyAddToCartBtn.querySelector('.loading-overlay__spinner');

        stickyAddToCartBtn.disabled = true;
        stickyAddToCartBtnContent.classList.add('hidden');
        stickyAddToCartBtnLoading.classList.remove('hidden');
        stickyAddToCartOptions.forEach((option) => {
          option.disabled = true;
          option.parentElement.querySelector('button').disabled = true;
        });
      }
      /* End - Sticky Add to Cart */

      const buttonLoading = this.submitButton.querySelector('.loading-overlay__spinner');
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.disabled = true;
      this.submitButton.classList.add('loading');
      if (buttonLoading != null) {
        buttonLoading.classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      let quantity = 1;
      let quantityField = this.form.querySelector('[name="quantity"]');
      if (quantityField == null) {
        formData.append('quantity', quantity);
      } else {
        quantity = quantityField.value;
      }
      let id = this.form.querySelector('[name="id"]').value;

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) =>{
          checkCartItems();
          return response.json()
        })
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.disabled = false;
            this.submitButton.querySelector('span').classList.add('hidden');
            
            this.error = true;
            return;
          } else if (!this.cart) {
            if (this.upsellModal == null || (!this.form.classList.contains('form--upsell') && !this.form.classList.contains('form--upsell-product'))) {
              window.location = window.routes.cart_url;
              return;
            }
          }

          this.error = false;
          if (this.upsellModal != null && (this.form.classList.contains('form--upsell') || this.form.classList.contains('form--upsell-product'))) {
            this.cart.renderContents(response, false);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.disabled = false;
          }
          if (buttonLoading != null) {
            buttonLoading.classList.add('hidden');
          }

          if (this.cancelButton != null) {
            this.submitButton.classList.add('hidden');
            this.cancelButton.classList.remove('hidden');
          }

          /* Start - Sticky Add to Cart */
          if (stickyAddToCart != null) {
            const stickyAddToCartOptions = stickyAddToCart.querySelectorAll('.nextdev--sticky-atc__product-options select');
            const stickyAddToCartButton = stickyAddToCart.querySelector('.nextdev--sticky-atc__product-button');
            const stickyAddToCartBtn = stickyAddToCartButton.querySelector('button');
            const stickyAddToCartBtnContent = stickyAddToCartBtn.querySelector('.button--content');
            const stickyAddToCartBtnLoading = stickyAddToCartBtn.querySelector('.loading-overlay__spinner');
          
            stickyAddToCartBtn.disabled = false;
            stickyAddToCartBtnLoading.classList.add('hidden');
            stickyAddToCartBtnContent.classList.remove('hidden');
            stickyAddToCartOptions.forEach((option) => {
              option.disabled = false;
              option.parentElement.querySelector('button').disabled = false;
            });
          }
          /* End - Sticky Add to Cart */
        });
    }

    onCancelHandler(evt) {
      evt.preventDefault();
      if (this.cancelButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const buttonLoading = this.cancelButton.querySelector('.loading-overlay__spinner');
      this.cancelButton.setAttribute('aria-disabled', true);
      this.cancelButton.disabled = true;
      this.cancelButton.classList.add('loading');
      if (buttonLoading != null) {
        buttonLoading.classList.remove('hidden');
      }

      const id = this.form.querySelector('[name="id"]').value;
      // Remove the line through the NextDev drawer: rowForVariant() finds the
      // row by variant id prefix, removeItem() posts the update and re-renders.
      const drawer = document.querySelector('nextdev-cart-drawer');
      const row = drawer && typeof drawer.rowForVariant === 'function' && drawer.rowForVariant(id);
      if (row) {
        drawer.removeItem(row);
      }
      
      setTimeout(() => {
        this.cancelButton.classList.remove('loading');
        if (buttonLoading != null) {
          buttonLoading.classList.add('hidden');
        }

        if (this.submitButton != null) {
          this.cancelButton.classList.add('hidden');
          this.submitButton.classList.remove('hidden');
        }
      }, 1000);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
